import { Controller } from "@hotwired/stimulus"

export default class ToastController extends Controller {
  static values = {
    duration: { type: Number, default: 8000 },
  }

  connect() {
    this.timeout = setTimeout(() => this.dismiss(), this.durationValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss() {
    this.element.remove()
  }
}
